import { fallBackLocale, supportedLocale } from '../constants';
import { REACT_APP_CONTEXT_PATH } from '../config';

export const flagSources = supportedLocale.reduce((obj, key) => {
  const countryCode = key.split('-')[1];
  return { ...obj, [countryCode]: `${REACT_APP_CONTEXT_PATH}/assets/images/flags/${countryCode.toLowerCase()}.png` };
}, {});

export const getCountryCode = (locale) => {
  const [lngCode, countryCode] = locale.split('-');
  const code = countryCode || lngCode.toUpperCase();
  return flagSources.hasOwnProperty(code) ? code : fallBackLocale.split('-')[1];
};
